import pyodideManifest from "../../scripts/pyodide-assets-manifest.json";
import { PythonRealmRefusal } from "./pythonRealmClient.js";

const MAX_DECLARED_PACKAGE_ROOTS = 8;

export const CURATED_PYTHON_PACKAGE_NAMES = Object.freeze([
    ...(pyodideManifest.curatedPackages?.roots || []),
].sort());

export const ON_DEMAND_PYTHON_PACKAGE_NAMES = Object.freeze([
    ...(pyodideManifest.onDemandPackages?.roots || []),
].sort());

export const APPROVED_PYTHON_PACKAGE_NAMES = Object.freeze([
    ...new Set([
        ...CURATED_PYTHON_PACKAGE_NAMES,
        ...ON_DEMAND_PYTHON_PACKAGE_NAMES,
    ]),
].sort());

const approvedPackageNames = new Set(APPROVED_PYTHON_PACKAGE_NAMES);
const onDemandPackageNames = new Set(ON_DEMAND_PYTHON_PACKAGE_NAMES);

export function isApprovedPythonPackage(name) {
    return approvedPackageNames.has(name);
}

export function isOnDemandPythonPackage(name) {
    return onDemandPackageNames.has(name);
}

export function normalizePythonPackageRequirements(value) {
    if (value === undefined || value === null) return [];
    if (
        !Array.isArray(value)
        || value.length > MAX_DECLARED_PACKAGE_ROOTS
        || value.some((name) => (
            typeof name !== "string"
            || !approvedPackageNames.has(name)
        ))
        || new Set(value).size !== value.length
    ) {
        throw new PythonRealmRefusal("package_requirements_invalid");
    }
    return [...value].sort();
}
